import { useState } from 'react'
import { Card, Form, Input, Switch, Select, Button, Slider, Space, Tabs, message, Upload } from 'antd'
import { SaveOutlined, UploadOutlined, ReloadOutlined } from '@ant-design/icons'

const { TabPane } = Tabs
const { Option } = Select

const SystemSettings = () => {
  const [form] = Form.useForm()
  const [activeTab, setActiveTab] = useState('basic')

  const handleSave = () => {
    message.success('设置已保存')
  }

  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <h1 className="text-2xl font-bold">🔧 系统设置</h1>
        <Space>
          <Button icon={<ReloadOutlined />}>重置为默认</Button>
          <Button type="primary" icon={<SaveOutlined />} onClick={handleSave}>
            保存设置
          </Button>
        </Space>
      </div>

      <Card>
        <Tabs activeKey={activeTab} onChange={setActiveTab}>
          <TabPane tab="基础配置" key="basic">
            <Form form={form} layout="vertical">
              <Form.Item label="系统名称" name="systemName" initialValue="招投标质疑数据标注平台">
                <Input />
              </Form.Item>
              <Form.Item label="系统Logo">
                <Upload>
                  <Button icon={<UploadOutlined />}>上传Logo</Button>
                </Upload>
              </Form.Item>
              <Form.Item label="主题配色" name="theme" initialValue="government">
                <Select>
                  <Option value="government">政务蓝（默认）</Option>
                  <Option value="dark">深色模式</Option>
                  <Option value="high-contrast">高对比度</Option>
                </Select>
              </Form.Item>
              <Form.Item label="系统语言" name="language" initialValue="zh-CN">
                <Select>
                  <Option value="zh-CN">简体中文</Option>
                  <Option value="zh-TW">繁體中文</Option>
                  <Option value="en">English</Option>
                </Select>
              </Form.Item>
            </Form>
          </TabPane>

          <TabPane tab="安全设置" key="security">
            <Form form={form} layout="vertical">
              <Form.Item label="登录方式">
                <Space>
                  <Switch checkedChildren="账号密码" unCheckedChildren="账号密码" defaultChecked />
                  <Switch checkedChildren="短信验证码" unCheckedChildren="短信验证码" />
                  <Switch checkedChildren="LDAP" unCheckedChildren="LDAP" />
                  <Switch checkedChildren="SSO" unCheckedChildren="SSO" />
                </Space>
              </Form.Item>
              <Form.Item label="密码策略" name="passwordPolicy" initialValue="medium">
                <Select>
                  <Option value="weak">弱（6位以上）</Option>
                  <Option value="medium">中等（8位以上+字母+数字）</Option>
                  <Option value="strong">强（12位以上+大小写+数字+特殊字符）</Option>
                </Select>
              </Form.Item>
              <Form.Item label="登录失败锁定">
                <Space>
                  <span>连续</span>
                  <Input style={{ width: 60 }} defaultValue={5} />
                  <span>次失败后锁定</span>
                  <Input style={{ width: 60 }} defaultValue={30} />
                  <span>分钟</span>
                </Space>
              </Form.Item>
              <Form.Item label="会话超时（分钟）" name="sessionTimeout" initialValue={30}>
                <Slider min={5} max={120} marks={{ 5: '5', 30: '30', 60: '60', 120: '120' }} />
              </Form.Item>
              <Form.Item>
                <Switch checkedChildren="开启" unCheckedChildren="关闭" defaultChecked />
                <span className="ml-2">强制密码定期更换（90天）</span>
              </Form.Item>
              <Form.Item>
                <Switch checkedChildren="开启" unCheckedChildren="关闭" defaultChecked />
                <span className="ml-2">异地登录提醒</span>
              </Form.Item>
            </Form>
          </TabPane>

          <TabPane tab="数据管理" key="data">
            <Form form={form} layout="vertical">
              <Form.Item label="数据备份">
                <Space>
                  <span>每天</span>
                  <Select defaultValue="02:00" style={{ width: 100 }}>
                    <Option value="00:00">00:00</Option>
                    <Option value="02:00">02:00</Option>
                    <Option value="04:00">04:00</Option>
                  </Select>
                  <span>执行备份，保留</span>
                  <Input style={{ width: 60 }} defaultValue={30} />
                  <span>天</span>
                </Space>
              </Form.Item>
              <Form.Item label="存储路径" name="storagePath" initialValue="/data/bidding_platform">
                <Input />
              </Form.Item>
              <Form.Item label="存储使用">
                <div className="w-full bg-gray-200 rounded-full h-4">
                  <div className="bg-blue-600 h-4 rounded-full" style={{ width: '78%' }}></div>
                </div>
                <div className="mt-2 text-sm text-gray-500">
                  已使用 780GB / 1TB (78%)
                </div>
              </Form.Item>
              <Form.Item>
                <Space>
                  <Button>清理临时文件</Button>
                  <Button>归档旧数据</Button>
                  <Button type="primary">立即备份</Button>
                </Space>
              </Form.Item>
            </Form>
          </TabPane>

          <TabPane tab="清洗配置" key="cleaning">
            <Form form={form} layout="vertical">
              <Form.Item label="OCR引擎" name="ocrEngine" initialValue="paddleocr">
                <Select>
                  <Option value="paddleocr">PaddleOCR (推荐)</Option>
                  <Option value="rapidocr">RapidOCR</Option>
                  <Option value="tesseract">Tesseract</Option>
                </Select>
              </Form.Item>
              <Form.Item label="并发数" name="ocrConcurrency" initialValue={4}>
                <Slider min={1} max={8} marks={{ 1: '1', 4: '4', 8: '8' }} />
              </Form.Item>
              <Form.Item label="超时时间（秒）" name="ocrTimeout" initialValue={300}>
                <Slider min={60} max={600} step={60} marks={{ 60: '60', 300: '300', 600: '600' }} />
              </Form.Item>
              <Form.Item label="预标注模型" name="preannotationModel" initialValue="qwen-14b">
                <Select>
                  <Option value="qwen-14b">Qwen-14B-Chat</Option>
                  <Option value="qwen-7b">Qwen-7B-Chat</Option>
                  <Option value="gpt-4">GPT-4 (API)</Option>
                </Select>
              </Form.Item>
              <Form.Item label="模型API地址" name="preannotationApiUrl" initialValue="http://localhost:8000">
                <Input />
              </Form.Item>
              <Form.Item>
                <Button>配置清洗规则</Button>
              </Form.Item>
            </Form>
          </TabPane>

          <TabPane tab="通知设置" key="notification">
            <Form form={form} layout="vertical">
              <Form.Item label="通知事件">
                <Space direction="vertical">
                  <Switch checkedChildren="开启" unCheckedChildren="关闭" defaultChecked />
                  <span>任务分配通知</span>
                  <Switch checkedChildren="开启" unCheckedChildren="关闭" defaultChecked />
                  <span>审核提醒</span>
                  <Switch checkedChildren="开启" unCheckedChildren="关闭" defaultChecked />
                  <span>系统公告</span>
                </Space>
              </Form.Item>
              <Form.Item label="通知渠道">
                <Space>
                  <Switch checkedChildren="站内信" unCheckedChildren="站内信" defaultChecked />
                  <Switch checkedChildren="邮件" unCheckedChildren="邮件" />
                  <Switch checkedChildren="短信" unCheckedChildren="短信" />
                </Space>
              </Form.Item>
              <Form.Item label="管理员邮箱" name="adminEmail" initialValue="admin@example.com">
                <Input />
              </Form.Item>
            </Form>
          </TabPane>

          <TabPane tab="集成配置" key="integration">
            <Form form={form} layout="vertical">
              <Form.Item label="Elasticsearch">
                <Space>
                  <span className="text-green-500">●</span>
                  <span>已连接</span>
                  <Input style={{ width: 200 }} defaultValue="http://es:9200" />
                  <Button>测试连接</Button>
                </Space>
              </Form.Item>
              <Form.Item label="Neo4j">
                <Space>
                  <span className="text-green-500">●</span>
                  <span>已连接</span>
                  <Input style={{ width: 200 }} defaultValue="bolt://neo4j:7687" />
                  <Button>测试连接</Button>
                </Space>
              </Form.Item>
              <Form.Item label="Milvus">
                <Space>
                  <span className="text-red-500">●</span>
                  <span>未连接</span>
                  <Input style={{ width: 200 }} defaultValue="http://milvus:19530" />
                  <Button type="primary">重连</Button>
                </Space>
              </Form.Item>
            </Form>
          </TabPane>
        </Tabs>
      </Card>
    </div>
  )
}

export default SystemSettings
